var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12,
    fill: "none",
    viewBox: "0 0 10 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A3B3BF",
    d: "M10 6.00102C10 6.30001 9.695 6.51502 9.695 6.51502L1.134 11.818C0.51 12.227 0 11.924 0 11.149V0.852015C0 0.0750149 0.51 -0.225985 1.135 0.182015L9.696 5.48702C9.695 5.48702 10 5.70202 10 6.00102Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.53277fcd1aaa506c88732621153f25ae.svg";
export { ForwardRef as ReactComponent };